<template>
  <div class="center aligned" style="width: 100%">
    <div class="ui cards" style="justify-content: center; display: flex; padding-top: 10px;">
      <div class="card" >
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="dolly flatbed huge icon"></i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Supplier
          </div>
        </div>
        <div class="extra content">
          <div class="ui two tiny buttons">
            <div class="ui blue button"
                 style="width: 40%; background-color: #092442 !important;"
                 @click="navigateTo('Suppliers')">
              Suppliers
            </div>
            <div class="or"></div>
            <div class="ui blue button"
                 style="background-color: #092442 !important;"
                 @click="navigateTo('New_Supplier')">
              New Supplier
            </div>
          </div>
        </div>
      </div>

      <div class="card" >
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="syringe huge icon"></i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Items
          </div>
        </div>
        <div class="extra content">
          <div class="ui two tiny buttons">
            <div class="ui blue button"
                 style="width: 40%; background-color: #092442 !important;"
                 @click="navigateTo('Items')">
              Items
            </div>
            <div class="or"></div>
            <div class="ui blue button"
                 style="background-color: #092442 !important;"
                 @click="navigateTo('New_Item')">
              New Item
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="$auth.user().see_invoices">
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="dollar sign huge icon"></i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Invoices
          </div>
        </div>
        <div class="extra content">
          <div class="ui two tiny buttons">
            <div class="ui blue button"
                 style="width: 30%; background-color: #092442 !important;"
                 @click="navigateTo('Invoices')">
              Invoices
            </div>
            <div class="or"></div>
            <div class="ui blue button"
                 style="background-color: #092442 !important;"
                 @click="navigateTo('New_Purchased_Invoice')">
              New Purchase Invoice
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="$auth.user().see_invoices">
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="huge icons">
            <i class="file outline icon"></i>
            <i class="corner zoom-in icon"></i>
          </i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Audit
          </div>
        </div>
        <div class="extra content">
          <div class="ui blue fluid tiny button"
               style="background-color: #092442 !important;"
               @click="navigateTo('Audit')">
            Show Report
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>
  .card {
    background-color: #f5f5f5 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/inventory_layout/InventoryHomePage.vue